module.exports = __webpack_public_path__ + "img/L 02.96d832af.png";